module.exports = __webpack_public_path__ + "img/network_error.0018ebf9.png";